<template>
    <panel-template>
        <template #bradcrumbs>
            <ui-breadcrumbs>
                <template #left>
                    <router-link :to="{name: 'products-list'}">
                        Empreendimentos
                    </router-link>
                    <a @click="link()"/> &#8226;
                    <a :href="`/empreendimentos/${product.id}/visualizar`">{{ product.name }}</a> &#8226;
                    <router-link to="#">Etapa 4</router-link>
                </template>
            </ui-breadcrumbs>

            <ui-panel-topbar :title="`${product.name}`" container>
                <template #right>
                    <a :href="`/empreendimentos/${product.id}/visualizar`">
                        <ui-button design="light md">Visualizar</ui-button>
                    </a>
                    <ui-menu-card>
                        <ui-button @click="removeConfirm">Excluir Empreendimento</ui-button>
                    </ui-menu-card>
                </template>
            </ui-panel-topbar>
        </template>

        <template #content>
            <div class="steps-menu">
                <div class="steps-menu-row">
                    <a :href="`/empreendimentos/etapa1/${product.id}`">1º Dados do Empreendimento</a>
                    <a :href="`/empreendimentos/etapa2/${product.id}`">2º Disponibilidade e Reservas</a>
                    <a :href="`/empreendimentos/etapa3/${product.id}`">3º Gestão de Unidades</a>
                    <router-link to="#" class="active">4º Gestão de Tabela de Vendas</router-link>
                </div>
            </div>

            <ui-modal-message
                name="delete-product"
                title="Tem certeza que deseja excluir este empreendimento?"
                text="Não será possível desfazer essa ação."
                btn-type="danger"
                btn-text="Confirmar"
            />

            <router-view />
        </template>
    </panel-template>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { product } from '@/services/axios'
	import { uiBreadcrumbs, uiPanelTopbar, uiMenuCard } from '@/components/ui'
	import { uiModalMessage } from '@/components/ui/modal'

	import PanelTemplate from '@/templates/page-panel-center'
	import helpers from '@/mixins/helpers'

	import { mapGetters } from 'vuex'

	export default {
		name: "ui-products-steps",
		components: {
			PanelTemplate,
			uiBreadcrumbs,
			uiPanelTopbar,
			uiMenuCard,
			uiButton,
			uiModalMessage,
		},
		mixins: [helpers],
		computed: mapGetters('product', {
			product: 'getProduct',
		}),
		created() {
			this.$root.$on('modal-msg-event-delete-product', (payload) => {
				if (payload.action) this.remove()
			})
		},
		methods: {
			details() {
				console.log('details')
			},
			remove() {
				product
					.delete('', this.product.id)
					.then((response) => {
						this.$toastr.s(response.data.msg)
						this.oldPanelLinkButton('empreendimentos/listar')
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log('error', error)
					})
			},
			/**
			 * Emite o evento para abrir o modal de confirmação de exclusão
			 */
			removeConfirm() {
				this.$root.$emit('modal-msg-open-delete-product')
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
